"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEquivalentTimezone = exports.convertDateToTimezone = exports.convertDate = void 0;
const tslib_1 = require("tslib");
const countryUtils_1 = require("./countryUtils");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
const convertDate = (fromDate, toDate, countryCode, timezoneSelectedByUser) => {
    const chosenTz = (0, exports.getEquivalentTimezone)(countryCode);
    if (chosenTz) {
        const fromDateMoment = moment_timezone_1.default
            .unix(fromDate)
            .tz(timezoneSelectedByUser)
            .startOf("d")
            .add(12, "h")
            .tz(chosenTz === null || chosenTz === void 0 ? void 0 : chosenTz.name, true);
        const toDateMoment = moment_timezone_1.default
            .unix(toDate)
            .tz(timezoneSelectedByUser)
            .startOf("d")
            .add(12, "h")
            .tz(chosenTz === null || chosenTz === void 0 ? void 0 : chosenTz.name, true);
        const daysDifference = toDateMoment.diff(fromDateMoment, "days") + 1;
        return { fromDateMoment, toDateMoment, daysDifference, chosenTz };
    }
    else {
        throw new Error(`No valid timezone`);
    }
};
exports.convertDate = convertDate;
const convertDateToTimezone = (date, timezoneSelectedByUser, chosenTz) => {
    return moment_timezone_1.default
        .unix(date)
        .tz(timezoneSelectedByUser)
        .startOf("d")
        .add(12, "h")
        .tz(chosenTz === null || chosenTz === void 0 ? void 0 : chosenTz.name, true);
};
exports.convertDateToTimezone = convertDateToTimezone;
const getEquivalentTimezone = (countryCode) => {
    const ISOCountryCode = (0, countryUtils_1.countryCodeToISO2)(countryCode);
    const sortedArray = moment_timezone_1.default.tz
        .zonesForCountry(ISOCountryCode)
        .map((z) => moment_timezone_1.default.tz.zone(z))
        .filter((z) => Boolean(z))
        .map((z) => {
        return z.utcOffset((0, moment_timezone_1.default)("2023-01-01T00:00:00Z").valueOf());
    })
        .sort((a, b) => {
        return a - b;
    });
    const median = sortedArray[Math.floor(sortedArray.length / 2)];
    const offset = median && Math.round(median / 60) * 60;
    const etcTimezones = moment_timezone_1.default.tz
        .names()
        .filter((n) => n.includes("Etc/"))
        .map((n) => moment_timezone_1.default.tz.zone(n));
    const chosenTz = etcTimezones.find((t) => (t === null || t === void 0 ? void 0 : t.offsets[0]) === offset);
    return chosenTz;
};
exports.getEquivalentTimezone = getEquivalentTimezone;
//# sourceMappingURL=dateUtils.js.map